function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 9
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd",
  strokeMiterlimit: 8
}, React.createElement("path", {
  className: "icon-tertiary",
  d: "m11.96 32.004 0.46453-6.314c-8.7463-1.7684-12.429-6.1849-8.2257-9.8641 4.2033-3.6794 14.7-5.2286 23.447-3.4602 8.7463 1.7684 12.429 6.1849 8.2269 9.8641-3.1049 2.7157-9.815 4.3674-16.961 4.1747z",
  fill: "#fff",
  stroke: "#002060"
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m17.4 19.027c0-1.4619 1.1785-2.6471 2.6347-2.6471s2.6347 1.1852 2.6347 2.6471c0 1.4619-1.1785 2.6471-2.6347 2.6471s-2.6347-1.1852-2.6347-2.6471z",
  fill: "#adb9ca"
}), React.createElement("path", {
  d: "m8.4664 19.027c0-1.4619 1.1796-2.6471 2.6347-2.6471 1.4563 0 2.6347 1.1852 2.6347 2.6471s-1.1785 2.6471-2.6347 2.6471c-1.455 0-2.6347-1.1852-2.6347-2.6471z",
  fill: "#ecaec6"
}), React.createElement("path", {
  d: "m26.461 19.027c0-1.4619 1.1785-2.6471 2.6347-2.6471s2.6347 1.1852 2.6347 2.6471-1.1785 2.6471-2.6347 2.6471-2.6347-1.1852-2.6347-2.6471z",
  fill: "#ecaec6"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8
}, React.createElement("path", {
  d: "m8.5653 19.069c0-1.3682 1.1298-2.4774 2.5235-2.4774 1.3948 0 2.5235 1.1092 2.5235 2.4774 0 1.3682-1.1287 2.4774-2.5235 2.4774-1.3936 0-2.5235-1.1092-2.5235-2.4774z"
}), React.createElement("path", {
  d: "m17.491 19.069c0-1.3682 1.1287-2.4774 2.5235-2.4774 1.3948 0 2.5235 1.1092 2.5235 2.4774 0 1.3682-1.1287 2.4774-2.5235 2.4774-1.3948 0-2.5235-1.1092-2.5235-2.4774z"
}), React.createElement("path", {
  d: "m26.492 19.069c0-1.3682 1.1287-2.4774 2.5235-2.4774 1.3948 0 2.5235 1.1092 2.5235 2.4774 0 1.3682-1.1287 2.4774-2.5235 2.4774-1.3948 0-2.5235-1.1092-2.5235-2.4774z"
}));

var SvgMenuTextIcon = function SvgMenuTextIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuTextIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-text-icon.5bbb5d67.svg";
export { ForwardRef as ReactComponent };